// 权限
export type UserAuthority =
  | 'userManage'
  | 'prescriptionManage'
  | 'channelManage'
  | 'freightManage'
  | 'drugManage'
  | 'afterSaleManage'
  | string

// 药店类型
export enum DrugStoreType {
  Western = 1,
  Chinese = 2,
  All = 3,
}

// 中药店类型
export enum CnMedDrugStoreType {
  YinPian = 1,
  Keli = 2,
  All = 3,
}

// 分页相关参数，和后端接口对应
export interface PaginationQuery {
  /** 当前页数 */
  page: number
  /** 每页条数 */
  limit: number
}

// 分页返回数据
export interface PaginationReturnData<T> {
  total: number
  list: T[]
}

export enum WorkStatus {
  /** 休息 */
  resting = 0,
  /** 工作中 */
  working,
}

/**
 * 处方状态
 *
 * @enum {number}
 */
export enum PrescriptionSearchStatus {
  /** 全部 */
  all = 0,
  /** 审核未通过 */
  deny = 1,
  /** 待审核 */
  pending = 2,
  /** 审核通过 */
  approve = 3,
  /** 已失效 */
  invalid = 4,
  /** 已使用 */
  used = 5,
}

export enum PrescriptionAuditStatus {
  deny = -1,
  approve = 1,
  pending = 0,
}

/**
 * 印章类型
 * 1:测试 2:日照  3:银川 4:海尔森'
 *
 * @enum {number}
 */
export enum SeaType {
  DEFAULT = 0,

  // 测试
  TEST = 1,

  // 日照
  RZ = 2,

  // 银川
  YC = 3,

  // 海尔森
  HES = 4,

  // 燕化
  YAN_HUA = 5,
  // 企鹅杏仁
  QEXR = 6,
}
/**
 * 到店取药处方类型
 * 1 - 待取药, 2 - 已取药
 */
export enum ToStoreTakeDrugPrescriptionStatus {
  /** 待取药 */
  waitTake = 1,
  /** 已取药 */
  doneTake,
}

/**
 * 处方材质类型
 * 1 - 纸质，2 - 电子
 *
 * @enum {number}
 */
export enum PrescriptionMaterialType {
  /** 全部 */
  all = 0,
  /** 纸质 */
  paper,
  /** 电子 */
  electronic,
}

/**
 * 处方标签
 * 5 - 线下b2b2c，6 - 线上b2b2c
 *
 * @enum {number}
 */
export enum PrescriptionLabelType {
  /** 线下b2b2c */
  Prb2b2cStoreTag = 5,
  /** 线上b2b2c */
  Prb2b2cOnlineTag = 6,
  /**
   * 歌礼项目
   * https://www.tapd.cn/20096901/prong/stories/view/1120096901001033294
   */
  GeliProject = 7,
  // 续方预约单
  Appointment = 8,
}

/**
 * 处方类型
 * 1 - 普通处方，2 - 快速处方，3 - 开药门诊处方
 *
 * @enum {number}
 */
export enum PrescriptionType {
  /** 普通处方 */
  common = 1,
  /** 快速处方 */
  quick,
  /** 开药门诊 */
  outpatient,
}

/**
 * 性别
 * 0 - 未知，1 - 男，2 - 女
 *
 * @enum {number}
 */
export enum Gender {
  /** 未知 */
  unknown = 0,
  /** 男 */
  male,
  /** 女 */
  female,
}

/**
 * 运费模板类型
 *
 * @enum {number}
 */
export enum FreightTemplateType {
  /** 统一运费 */
  fixed = 1,
  /** 指定包邮（满减） */
  freeShippingOver,
}

/**
 * 运费模版计价方式
 *
 * @enum {number}
 */
export enum FreightTemplateValuationType {
  /** 按订单 */
  ByOrder = 1,
  /** 按商品 */
  ByCommodity = 2,
}

/* 药物类型
 * -1 - 全部，0 - 处方药，1 - 非处方药
 *
 * @enum {number}
 */
export enum DrugsType {
  /** 全部 */
  all = -1,
  /** 处方药 */
  prescription = 0,
  /** 非处方药 */
  otc = 1,
}

/**
 * 医保类型
 * 0 - 非医保，1 - 甲, 2 - 乙，3 - 兵，4 - 民族药
 *
 * @enum {number}
 */
export enum MedicareType {
  /** 非医保 */
  NonMedical,
  /** 甲 */
  A,
  /** 乙 */
  B,
  /** 丙 */
  C,
  /** 民族药 */
  EthnicMedicine,
}

/**
 * 处方药品类型
 * 0 - 未知，1 - 西药/中成药，2 - 中药，3 - 中草药
 */
export enum PrescriptionDrugType {
  /** 西药/中成药 */
  DGWesternOrChinesePatent = 1,
  /** 中药 */
  DGChineseMedicine,
  /** 中草药 */
  DGChineseHerbal,
}

/**
 * 定价模式
 */
export enum StoreModelSetting {
  /** 高开模式 */
  HighOpen = 1,
  /** 加成模式 */
  MarkUp = 2,
}
/** -------------------- 医生认证状态 -------------------- */
// 0 注册用户 1 实名认证 2 健康服务认证 3 多点执业
export enum DoctorVerifyStatus {
  REGISTERED = 0,
  VERIFIED = 1,
  HEALTH_CERTIFICATION = 2,
  PRACTICE_MORE = 3,
}

/** -------------------- 通知类型 -------------------- */
// 1 下架通知 2 失效通知 3 审核通过 4 审核驳回 
export enum NoticeType {
  OffLine = 1,
  Invalid = 2,
  ExamPass = 3,
  ExamReject = 4,
  RemindDelivery = 5,
  CertificateExpired = 6,
}

/** -------------------- 通知是否阅读 -------------------- */
// 0 未读 1 已读
export enum NoticeReadStatus {
  NoRead = 0,
  Read = 1,
}

/** -------------------- 批量发货类型 -------------------- */
// 1 顺丰 2 快递100 3 不订阅物流（其他） 4 京东
export enum LogisticCreatedBy {
  SF = 1,
  KUAIDI100 = 2,
  NO_SUBSCRIBE = 3,
  JD = 4,
  JDV2 = 5,
}

